// extracted by mini-css-extract-plugin
module.exports = {"advantage":"Advantages_advantage__8znAe","advantages":"Advantages_advantages__iP4RV"};